<template>
  <div class="goTop" v-show="goTop" @click="goTopfun"><i class="el-icon-caret-top"></i></div>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
      goTop: false
    }
  },
  mounted () {
    // 此处true需要加上，不加滚动事件可能绑定不成功
    window.addEventListener('scroll', this.handleScroll, true)
  },
  methods: {
    handleScroll () {
      let scrolltop = document.documentElement.scrollTop || document.body.scrollTop
      scrolltop > 100 ? (this.goTop = true) : (this.goTop = false)
    },
    goTopfun () {
      let top = document.documentElement.scrollTop || document.body.scrollTop
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = top -= 50
        if (top <= 0) {
          clearInterval(timeTop)
        }
      }, 10)
    }
  }
}
</script>

<style lang="scss">
.goTop{
  position: fixed;
  background-color: #fff;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  left: 50%;
  margin-left: 624px;
  color: #b2bac2;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.04);
  cursor: pointer;
  z-index: 5;
  bottom: 10%;
  &:hover{
    transition: all 0.3s;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  }
  @media only screen and (max-width: 1440px){
    width: 40px;
    height: 40px;
    margin-left: 612px;
    bottom: 14%;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/gotop/index.vue